import { render, staticRenderFns } from "./sponsor_expo_edit.vue?vue&type=template&id=399dcef1&scoped=true&"
import script from "./sponsor_expo_edit.vue?vue&type=script&lang=js&"
export * from "./sponsor_expo_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399dcef1",
  null
  
)

export default component.exports